import { render, staticRenderFns } from "./SportsLayout.vue?vue&type=template&id=9f467ca2&scoped=true"
import script from "./SportsLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportsLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SportsLayout.vue?vue&type=style&index=0&id=9f467ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f467ca2",
  null
  
)

export default component.exports